import React from 'react';
import './AssistantWaitIndicator.css';

const AssistantWaitIndicator = ({ assistantName = 'AVE' }) => {
  return (
    <div
      className="assistant-wait-indicator"
      role="status"
      aria-live="polite"
      aria-label={`${assistantName} está preparando la respuesta. Gracias por tu paciencia.`}
    >
      <div className="assistant-wait-spinner" aria-hidden="true">
        <span className="assistant-wait-spinner-ring"></span>
      </div>

      <div className="assistant-wait-copy">
        <span className="assistant-wait-title">{assistantName} está preparando la respuesta</span>
        <span className="assistant-wait-message">
          Gracias por tu paciencia. Estoy trabajando en generar la respuesta y atendiendo otras solicitudes en simultáneo.
        </span>
        <div className="assistant-wait-progress" aria-hidden="true">
          <span></span>
        </div>
      </div>
    </div>
  );
};

export default AssistantWaitIndicator;
